import { X } from "lucide-react";
import excelSheet from "../../../assets/icons/excelSheet.svg";

const SelectedExcelFile = ({ selectedSheetName, removeSelectedFile }) => {
  return (
    <span className="text-[10px] lg:text-xs font-poppins bg-lg5 px-2 rounded-full py-1 text-dark-blue 2xs:max-sm:py-0 inline-flex items-center">
      <img src={excelSheet} alt="fileIcon" className="w-4 lg:w-6" />
      <span className="px-2">{selectedSheetName}</span>
      <X color="red" width={18} className="cursor-pointer" onClick={removeSelectedFile} />
    </span>
  );
};

export default SelectedExcelFile;
